import { Component, Input } from '@angular/core';


@Component({
  selector: 'tis-icon',
  imports: [],
  templateUrl: './tis-icon.component.html',
  styleUrls: ['./tis-icon.component.scss'],
  standalone: true,
})
export class TisIconComponent {
  @Input() classes: string = "";
  @Input() styles: string = "";
  @Input() appearance: "outlined" | "filled" = "outlined";
  @Input() fontWeight: `100` | `200` | `300` | `400` | `500` | `600` | `700` = `200`;
  @Input() icon: string = "";
}
